// Environment Configuration
const getEnvironmentConfig = () => {
  // Detect environment more robustly
  let env = process.env.REACT_APP_ENV;
  
  // If REACT_APP_ENV is not set, try to detect from window.location
  if (!env && typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'staging.expenses.metrica.co.il' || hostname.includes('d13yte2iwdas3i.cloudfront.net')) {
      env = 'staging';
    } else if (hostname === 'expenses.metrica.co.il' || hostname.includes('d3nxc4mvyt9sv9.cloudfront.net')) {
      env = 'prod';
    } else if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
      env = 'development';
    } else {
      env = 'development'; // fallback
    }
  }
  
  // Final fallback
  env = env || 'development';
  
  const configs = {
    development: {
      api: {
        baseUrl: process.env.REACT_APP_API_URL || 'https://a1wf6oqumg.execute-api.il-central-1.amazonaws.com/prod',
        timeout: 10000,
      },
      app: {
        name: 'Metrica',
        version: '1.0.0',
        environment: 'development',
      },
      oauth: {
        google: {
          clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '265043269478-ahv3i6516aah1pi7bsq6e14tp33dlgh5.apps.googleusercontent.com',
          redirectUri: 'http://localhost:3000/auth/callback',
        },
      },
      features: {
        debug: true,
        analytics: false,
      },
    },
    staging: {
      api: {
        baseUrl: process.env.REACT_APP_API_URL || 'https://b4ciur7d41.execute-api.il-central-1.amazonaws.com/staging',
        timeout: 15000,
      },
      app: {
        name: 'Metrica',
        version: '1.0.0',
        environment: 'staging',
      },
      oauth: {
        google: {
          clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '265043269478-ahv3i6516aah1pi7bsq6e14tp33dlgh5.apps.googleusercontent.com',
          redirectUri: 'https://staging.expenses.metrica.co.il/auth/callback',
        },
      },
      features: {
        debug: true,
        analytics: true,
      },
    },
    prod: {
      api: {
        baseUrl: process.env.REACT_APP_API_URL || 'https://a1wf6oqumg.execute-api.il-central-1.amazonaws.com/prod',
        timeout: 20000,
      },
      app: {
        name: 'Metrica',
        version: '1.0.0',
        environment: 'production',
      },
      oauth: {
        google: {
          clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '265043269478-ahv3i6516aah1pi7bsq6e14tp33dlgh5.apps.googleusercontent.com',
          redirectUri: 'https://expenses.metrica.co.il/auth/callback',
        },
      },
      features: {
        debug: false,
        analytics: true,
      },
    },
  };

  return configs[env as keyof typeof configs] || configs.development;
};

export const config = getEnvironmentConfig();

// Helper function to get API URL with endpoint
export const getApiUrl = (endpoint: string): string => {
  const baseUrl = config.api.baseUrl.replace(/\/$/, ''); // Remove trailing slash
  const cleanEndpoint = endpoint.replace(/^\//, ''); // Remove leading slash
  return `${baseUrl}/${cleanEndpoint}`;
};

export default config; 